//replaces search-table-with-header-single.html
import type { FC } from "react";

import MetricsCompareBars from "app/components/React/MetricsCompareBars/MetricsCompareBars";
import { MiniFlexTable } from "app/components/React/Table/FlexTable/Mini/MiniFlexTable";
import { SWReactTable } from "app/components/React/Table/SWReactTable";
import { TableNoData } from "app/components/table-no-data/TableNoData";
import { WidgetLegendContainerV2 } from "app/dashboards/view-components/widget-legend/WidgetLegendContainer-v2";

import type { IDashboardWidgetInterface } from "../utils/DashboardWidgetsInterfaces-v2";

import type { ITableWidget } from "./TableTemplate-v2";

export const SearchTableWithHeaderCompareTemplateV2: FC<IDashboardWidgetInterface<ITableWidget>> = (props) => {
    const { widget } = props;
    return (
        <>
            {widget.viewOptions.tableCompareLegend ? (
                <WidgetLegendContainerV2
                    widget={widget}
                    className="swWidget-legend geography-table-legend"
                    items={widget.legendItems}
                />
            ) : null}
            <MetricsCompareBars
                // @ts-expect-error Type '{}' is incompatible with type 'Item[]'
                items={widget.getCompareBarsItems()}
                textMinValue={7}
            />
            <hr className="KeywordsOverviewHeader-separator-compare" />
            {widget.metadata.options.tableType === "widgetTable" && widget.data.Records.length ? (
                <SWReactTable
                    tableData={widget.data}
                    tableColumns={widget.metadata.columns}
                    tableOptions={widget.metadata.options}
                    onSort={widget.onSort}
                    onItemClick={widget.onItemClick}
                    onItemToggleSelection={widget.onToggleSelection}
                    onSelectAllRows={widget.selectAllPageRows}
                    className={widget.tableClassName}
                />
            ) : null}
            {widget.metadata.options.tableType === "swTable--simple" && widget.data.Records.length ? (
                <MiniFlexTable
                    tableData={widget.data}
                    tableColumns={widget.metadata.columns}
                    tableOptions={widget.metadata.options}
                    tablePayload={{ items: widget.data.Items }}
                />
            ) : null}
            {widget.metadata.options.emptyResults ? <TableNoData config={widget.errorConfig} /> : null}
        </>
    );
};
